/* eslint-disable no-console */
// ============================================================
// Service Worker Registration for AIB Bank PWA
// ============================================================
// This module handles registering, updating, and unregistering
// the service worker. Import and call register() in index.tsx.
// ============================================================

type Config = {
  onSuccess?: (registration: ServiceWorkerRegistration) => void;
  onUpdate?: (registration: ServiceWorkerRegistration) => void;
};

export function register(config?: Config): void {
  if ('serviceWorker' in navigator) {
    // The service worker file is in the public folder
    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

    // Always register the service worker (both localhost and production)
    // so that PWA install criteria are met and beforeinstallprompt fires.
    registerValidSW(swUrl, config);
  }
}

function registerValidSW(swUrl: string, config?: Config): void {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      console.log('[PWA] Service Worker registered successfully');

      // Check for updates periodically (every 60 minutes)
      setInterval(() => {
        registration.update();
        console.log('[PWA] Checking for service worker updates...');
      }, 1000 * 60 * 60);

      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }

        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // New content is available; notify the user
              console.log(
                '[PWA] New content is available and will be used when all ' +
                  'tabs for this page are closed.'
              );

              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              // Content is cached for offline use
              console.log('[PWA] Content is cached for offline use.');

              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error('[PWA] Error during service worker registration:', error);
    });
}

export function unregister(): void {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
        console.log('[PWA] Service Worker unregistered');
      })
      .catch((error) => {
        console.error('[PWA] Error unregistering service worker:', error);
      });
  }
}
